import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { User } from '@angular/fire/auth';

@Injectable({
    providedIn: 'root'
})
export class MockAuthService {
    // Mock user
    private mockUser: any = {
        uid: 'test-user-id',
        displayName: 'Test User',
        email: 'test@example.com',
        photoURL: 'assets/avatar-placeholder.png'
    };

    private userSubject = new BehaviorSubject<User | null>(this.mockUser);
    user$ = this.userSubject.asObservable();

    constructor() {
        console.log('Using MockAuthService');
    }

    async login() {
        console.log('Mock login successful');
        this.userSubject.next(this.mockUser);
        return { user: this.mockUser };
    }

    async logout() {
        console.log('Mock logout successful');
        this.userSubject.next(null);
    }

    getCurrentUser() {
        return this.userSubject.value;
    }

    async updateProfileData(displayName: string, photoURL: string) {
        console.log('Mock profile updated', { displayName, photoURL });
        this.mockUser = { ...this.mockUser, displayName, photoURL };
    }

    async deleteUser() {
        console.log('Mock user deleted');
    }

    async linkGoogleDrive() {
        return 'mock-access-token';
    }
}
